<template>
  <div class="w-25 mx-auto d-flex justify-content-center text-grey-darken-2">
    <span class="my-auto material-symbols-outlined icon-24">
      arrow_right
    </span>
  </div>
</template>
<style scoped>
.icon-24 {
  font-size: 75px;
  line-height: 1;
}
</style>
